import React from "react";

export default function Review() {
	const reviews = [
		{
			text: "Team of Deera Graphics is just awesome. They have tons of predesigned logos, flyers and business cards starting from retro to modern style. Perfect choice for your next startup.",
			author: "Michael Gouch",
			position: "CEO at Hyper Technologies Pvt. Ltd.",
			image: "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/michael-gouch.png",
		},
	];

	return (
		<div className="bg-gradient-to-b from-purple-50 to-pink-50 relative overflow-hidden">
			{/* Decorative elements */}
			<div className="absolute inset-0">
				<div className="absolute w-72 h-72 bg-purple-200 rounded-full blur-3xl animate-float -top-20 -left-20 opacity-60" />
				<div className="absolute w-72 h-72 bg-pink-200 rounded-full blur-3xl animate-float-delayed bottom-0 right-0 opacity-60" />
			</div>

			<div className="max-w-screen-xl px-4 py-20 mx-auto relative z-10">
				<div className="grid gap-8 lg:grid-cols-2">
					{reviews.map((review, index) => (
						<div
							key={index}
							className="backdrop-blur-xl bg-white/80 p-10 rounded-3xl shadow-xl transform hover:scale-105 transition-all duration-300"
						>
							<div className="flex items-center mb-8">
								<span className="text-5xl text-purple-500 leading-none font-serif">
									"
								</span>
								<div className="h-px flex-1 bg-gradient-to-r from-purple-200 to-pink-200 ml-4" />
							</div>

							<p className="text-xl font-medium text-purple-900 mb-8 leading-relaxed">
								{review.text}
							</p>

							<div className="flex items-center">
								<img
									className="w-12 h-12 rounded-full ring-4 ring-purple-100"
									src={review.image}
									alt={review.author}
								/>
								<div className="ml-4">
									<div className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">
										{review.author}
									</div>
									<div className="text-purple-600 text-sm">
										{review.position}
									</div>
								</div>
							</div>
						</div>
					))}

					{/* Additional decorative card */}
					<div className="bg-gradient-to-br from-purple-500 to-pink-500 p-10 rounded-3xl text-white transform hover:scale-105 transition-all duration-300">
						<div className="text-4xl font-bold mb-4">
							Ready to Transform Your Brand?
						</div>
						<p className="text-purple-100 mb-8">
							Join our satisfied clients and elevate your business
							with stunning designs.
						</p>
						<button className="bg-white text-purple-600 px-8 py-3 rounded-xl font-bold hover:bg-purple-50 transition-colors">
							Get Started
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
